const is_dev = !process.env.REACT_APP_API_URL && process.env.NODE_ENV === "development";
export const is_prod = process.env.NODE_ENV === "production";

export const API_URL = process.env.REACT_APP_API_URL
  || (is_dev ? "http://localhost:8000" : "");

export const EMAIL_DEBOUNCE_TIMEOUT = 2000; // 2 seconds
